import dayjs from 'dayjs';

import { ACLOSET_SHOP_PLATFORM_TYPE_SHORT_CODE_MAP, type AclosetShopPlatformTypeCode } from '@/MetadataType';
import { constantList } from '@/constants/TextConstants';

import type { 상품관리_요청_타입 } from './type';

/**
 * 판매 액션시 보여줄 마켓 리스트
 */
export const 연동가능_플랫폼_코드_리스트: AclosetShopPlatformTypeCode[] = [
  constantList.PLATFORM_CAFE24,
  constantList.PLATFORM_NAVER_SMART_STORE,
  constantList.PLATFORM_ACLOSET,
];

/**
 * 비연동 마켓 리스트
 */
export const 연동불가능_플랫폼_코드_리스트: AclosetShopPlatformTypeCode[] = [
  constantList.PLATFORM_BUNJANG,
  constantList.PLATFORM_PLAYAUTO,
];

/**
 * 상품 관리 테이블에서 엑셀 다운로드 가능한 플랫폼 리스트 (플레이오토 제외)
 */
export const 상품관리_엑셀_다운로드_가능_플랫폼_코드_리스트: AclosetShopPlatformTypeCode[] = [
  ACLOSET_SHOP_PLATFORM_TYPE_SHORT_CODE_MAP['bunjang'],
];

/**
 * @see https://kr-api-dev.acloset.net/shops/swagger/index.html#/Sales/post_shops__shopID__sale_items_export_excel
 */
export const 업로드_엑셀_다운로드_가능_플랫폼_코드_리스트 = [
  'SHOP_PLATFORM-TYPE_BUNJANG',
  'SHOP_PLATFORM-TYPE_OKPOS',
  'SHOP_PLATFORM-TYPE_PLAYAUTO',
] as const;

export const 컬럼이름_플랫폼_코드_대치_리스트: Record<string, string[] | string> = {
  번개장터: ['bunjangDownloadStatus', 'bunjangDownloadTime'],
  인스타그램: ['instagramStatus', 'instagramEditor', 'instagramPostedDate', 'instagramPostLink'],
  카페24: ['cafe24Status', 'cafe24Price', 'cafe24Categories'],
  네이버: ['smartStoreStatus', 'smartStorePrice', 'smartStoreCategories'],
  세컨솔드: ['aclosetStatus', 'aclosetPrice', 'aclosetCategories'],
  판매상태: 'saleStatus',
  상품등록일: 'postDate',
  썸네일: 'thumbnail',
  최종수정일: 'modifyDate',
  상품명: 'title',
  상품코드: 'itemAlias',
  '통합 카테고리': 'aimsCategoryName',
};

/**
 * 상품 상태 매칭 (상품 목록 상태 필터에 사용)
 * sale, platform-status -> sale, status
 */
export const 플랫폼_상태_상품_상태_대치_맵: Record<string, string> = {
  'SALE_PLATFORM-STATUS_IDLE': 'SALE_STATUS_IDLE',
  'SALE_PLATFORM-STATUS_ON-SALE': 'SALE_STATUS_ON-SALE',
  'SALE_PLATFORM-STATUS_PENDING-MODIFYING': 'SALE_STATUS_PENDING-MODIFYING',
  'SALE_PLATFORM-STATUS_STOP-SALE': 'SALE_STATUS_STOP-SALE',
  'SALE_PLATFORM-STATUS_ORDER-PROCESSING': 'SALE_STATUS_ORDER-PROCESSING',
  'SALE_PLATFORM-STATUS_SALE-DONE': 'SALE_STATUS_SALE-DONE',
};

/**
 * 상품 상태 매칭 (상품 목록 상태 필터에 사용)
 * sale-status => platform-status
 */
export const PLATFORM_STATUS_FROM_SALE_STATUS: Record<string, string> = {
  SALE_STATUS_IDLE: 'SALE_PLATFORM-STATUS_IDLE',
  'SALE_STATUS_ON-SALE': 'SALE_PLATFORM-STATUS_ON-SALE',
  'SALE_STATUS_PENDING-MODIFYING': 'SALE_PLATFORM-STATUS_PENDING-MODIFYING',
  'SALE_STATUS_STOP-SALE': 'SALE_PLATFORM-STATUS_STOP-SALE',
  'SALE_STATUS_ORDER-PROCESSING': 'SALE_PLATFORM-STATUS_ORDER-PROCESSING',
  'SALE_STATUS_SALE-DONE': 'SALE_PLATFORM-STATUS_SALE-DONE',
  SALE_STATUS_DELETED: 'SALE_PLATFORM-STATUS_DELETED',
};

export const 상품관리_요청_초기값: 상품관리_요청_타입 = {
  from: dayjs().subtract(1, 'month').startOf('day').format(),
  to: dayjs().endOf('day').format(),
  searchPeriodType: 'postDate',
  itemAlias: '',
  title: '',
  supplierName: '',
  saleStatus: [
    // 'SALE_STATUS_DELETED', // 상품 삭제는 필터에서 사용하지 않음.
    'SALE_STATUS_IDLE', // 판매 전
    'SALE_STATUS_ON-SALE', // 판매 중
    'SALE_STATUS_ORDER-PROCESSING', // 주문 처리 중
    'SALE_STATUS_PENDING-MODIFYING', // 수정 대기
    'SALE_STATUS_SALE-DONE', // 판매 완료
    'SALE_STATUS_STOP-SALE', // 판매 중지
  ],
  platformType: '',
  pageNumber: 0,
  pageSize: 100,
  periodDateChip: '1개월',
  multiSearchType: 'itemAliases',
  multiSearchKeyword: undefined,
  saleOperation: undefined,
  aimsCategory: [],
  parentCategory: undefined,
  isPlatformStatusOnSaleAndStopSale: false,

  sort: 'desc',
  sortType: 'postDate',
};
